import React, { useState, useEffect } from 'react';
import CustomCard, { CustomFilterCard1, CustomGridLayout } from '../../../../shared/Cards/CustomCard';
import { confirmDelete } from '../../../../utils/commonFunctions';
import CustomDialog from '../../../../shared/Overlays/CustomDialog';
import CustomTable from '../../../../shared/Table/CustomTable';
import PrimaryButton from '../../../../shared/Button/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import { getCatalogItems } from '../../../../redux/actions/Settings/InventorySetup/catalogItemsAction';

const AddCatalog = ({ label, name, value, data, dialogTitle = 'Add Catelog', onChange }) => {
    const { allCatalogItems } = useSelector((state) => state.catalogItems);

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        setSelected(value || data?.[name]);
    }, [value, data]);

    useEffect(() => {
        dispatch(getCatalogItems());
    }, [dispatch]);

    const columns = [
        { field: 'name', header: 'Item Name' },
        { field: 'upc', header: 'Item UPC' },
        { field: 'netPrice', header: 'Price' },
        { field: 'defaultQuantity', header: 'Quantity' },
    ];

    const handleServiceDelete = (col) => {
        confirmDelete(
            () => {
                let _data = value || data?.[name];
                let _filtered = _data?.filter((item) => item._id !== col?._id);
                onChange({ name, value: _filtered });
            },
            `Do you want to delete this item?`,
            'center',
        );
    };

    const onOpenDialog = () => {
        setOpen(true);
    };
    const onCloseDialog = () => {
        setOpen(false);
    };
    const handleSave = () => {
        if (onChange) {
            onChange({ name, value: selected });
        }
        onCloseDialog();
    };
    return (
        <>
            <CustomCard col="12" title={label}>
                <CustomFilterCard1 buttonTitle="Add" onClick={onOpenDialog} extraClass="justify-content-end gap-2">
                    <div>
                        <PrimaryButton label="Remove All" />
                    </div>
                </CustomFilterCard1>
                <CustomTable data={value || data?.[name] || []} columns={columns} showSelectionElement={false} onDelete={handleServiceDelete} />
            </CustomCard>
            <CustomDialog title={dialogTitle} visible={open} onCancel={onCloseDialog} loading={loading} onSave={handleSave} width="auto">
                <CustomGridLayout>
                    <CustomTable
                        convertToboolean={false}
                        data={allCatalogItems}
                        columns={[{ selectionMode: 'multiple', headerStyle: '' }, ...columns]}
                        selectedRow={selected}
                        setSelectedRow={setSelected}
                    />
                </CustomGridLayout>
            </CustomDialog>
        </>
    );
};

export default AddCatalog;
